import React, {createContext, useReducer} from 'react'
import PropTypes from 'prop-types'

const initialState = {
    activeReturnShipmentId: '',
    currentOrder: null,
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_SHIPMENT':
            return {
                ...state,
                activeReturnShipmentId: action.payload,
            }
        default:
            return state
    }
}

export const OrderContext = createContext({})
export const ActionsContext = createContext({})

export const OrderProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    return (
        <ActionsContext.Provider value={dispatch}>
            <OrderContext.Provider value={state}>{children}</OrderContext.Provider>
        </ActionsContext.Provider>
    )
}

OrderProvider.propTypes = {
    children: PropTypes.node.isRequired,
}
